export const Status = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DELETED: "DELETED",
  PENDING: "PENDING",
  True:true,
  False:false,
  
};

export default Status;
